import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { takeUntil } from "rxjs/operators";
import { Subject, ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-filter-sort-dialog',
  templateUrl: './filter-sort-dialog.component.html',
  styleUrls: ['./filter-sort-dialog.component.scss']
})
export class FilterSortDialogComponent implements OnInit, OnDestroy {
  order = [];
  disciplines: any = [];
  journalTypes: any = [];
  tags: any = [];
  blogTypes: any = [];
  selectedOrder: string;

  public userFilterValue: FormControl = new FormControl('');
  public referenceFilterValue: FormControl = new FormControl('');

  selectedDisciplines: any = [];
  selectedJournalTypes: any = [];

  disciplineArray: any = [];
  journalTypeArray: any = [];
  tagArray: any = [];

  isLoading: boolean = false;
  selectable = true;
  removable = true;
  startDate: string = '';
  endDate: string = '';
  dateRange: string = '';
  selectedRange: string = '';
  editorial: boolean = false;
  filter: boolean = false;
  sort: boolean = false;

  public disciplineControl: FormControl = new FormControl();
  public journalTypeControl: FormControl = new FormControl();

  public tagControl: FormControl = new FormControl();

  public disciplineSearchControl: FormControl = new FormControl();
  public journalTypeSearchControl: FormControl = new FormControl();

  public searchTagControl: FormControl = new FormControl();

  public searchedDisciplines: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public searchedjournalTypes: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  public searchedTags: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  private _onDestroy = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<FilterSortDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.isLoading = true;
    if (this.data) {
      this.filter = this.data.filter;
      this.sort = this.data.sort;
      this.order = this.data.order;
      this.disciplines = this.data.disciplines;
      this.journalTypes = this.data.journalTypes;
      this.blogTypes = this.data.blogTypes;

      this.selectedOrder = this.data.selectedOrder;
      this.selectedDisciplines = [...this.data.selectedDisciplines];
      this.selectedJournalTypes = [...this.data.selectedJournalTypes];

      this.disciplineArray = [...this.data.disciplineArray];
      this.journalTypeArray = [...this.data.journalTypeArray];
      this.dateRange = this.data.dateRange;
      this.selectedRange = this.data.selectedRange;
      this.startDate = this.data.startDate;
      this.endDate = this.data.endDate;
      this.userFilterValue.setValue(this.data.userFilterValue);
      this.referenceFilterValue.setValue(this.data.referenceFilterValue);
      this.editorial = this.data.editorial;
    }

    this.isLoading = false;
    this.initSearchControls();
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  initSearchControls() {
    if (this.disciplines) {
      if (this.selectedDisciplines.length > 0) {
        this.disciplineControl.setValue(this.selectedDisciplines);
      } else {
        this.disciplineControl.setValue(null);
      }
      this.searchedDisciplines.next(this.disciplines.slice());
      this.disciplineSearchControl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterDisciplines();
        });
    }
    if (this.journalTypes) {
      if (this.selectedJournalTypes.length > 0) {
        this.journalTypeControl.setValue(this.selectedJournalTypes);
      } else {
        this.journalTypeControl.setValue(null);
      }
      this.searchedjournalTypes.next(this.journalTypes.slice());
      this.journalTypeSearchControl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterJournalTypes();
        });
    }

  }

  setEditorial(event) {
    this.editorial = event.checked;
  }


  toggleOrder(event) {
    this.selectedOrder = event.value;
  }

  filterDisciplines() {
    if (!this.disciplines) {
      return;
    }
    let search = this.disciplineSearchControl.value;
    if (!search) {
      this.searchedDisciplines.next(this.disciplines.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.searchedDisciplines.next(
      this.disciplines.filter(discipline => discipline.name.toLowerCase().indexOf(search) > -1)
    );
  }

  setDiscipline(discipline_obj) {
    if (!this.disciplineArray.includes(discipline_obj.id)) {
      this.disciplineArray.push(discipline_obj.id);
      this.selectedDisciplines.push(discipline_obj);
    }
    this.disciplineControl.setValue(this.selectedDisciplines);
  }
  setDateRange(range: any) {
    this.startDate = range.startDate;
    this.endDate = range.endDate;
    this.dateRange = range.startDate + ',' + range.endDate;
    this.selectedRange = range.selectedRange;
  }

  removeDiscipline(discipline_obj) {
    this.selectedDisciplines = this.selectedDisciplines.filter((item, value) => {
      return item.id !== discipline_obj.id;
    });
    const index = this.disciplineArray.indexOf(discipline_obj.id);
    if (index >= 0) {
      this.disciplineArray.splice(index, 1);
    }
    if (this.selectedDisciplines.length > 0) {
      this.disciplineControl.setValue(this.selectedDisciplines);
    } else {
      this.disciplineControl.setValue(null);
    }
  }

  removeDateRange() {
    this.dateRange = '';
    this.selectedRange = '';
    this.startDate = '';
    this.endDate = '';
  }

  filterJournalTypes() {
    if (!this.journalTypes) {
      return;
    }
    let search = this.journalTypeSearchControl.value;
    if (!search) {
      this.searchedjournalTypes.next(this.journalTypes.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.searchedjournalTypes.next(
      this.journalTypes.filter(journalType => journalType.name.toLowerCase().indexOf(search) > -1)
    );
  }

  setJournalType(journalType_obj) {
    if (!this.journalTypeArray.includes(journalType_obj.id)) {
      this.journalTypeArray.push(journalType_obj.id);
      this.selectedJournalTypes.push(journalType_obj);
    }
    this.journalTypeControl.setValue(this.selectedJournalTypes);
  }

  removeJournalType(journalType_obj) {
    this.selectedJournalTypes = this.selectedJournalTypes.filter((item, value) => {
      return item.id !== journalType_obj.id;
    });
    const index = this.journalTypeArray.indexOf(journalType_obj.id);
    if (index >= 0) {
      this.journalTypeArray.splice(index, 1);
    }
    if (this.selectedJournalTypes.length > 0) {
      this.journalTypeControl.setValue(this.selectedJournalTypes);
    } else {
      this.journalTypeControl.setValue(null);
    }
  }

  reset(sort: boolean = true) {
    if (sort) {
      this.selectedOrder = this.order[0].type;
    } else {
      this.selectedDisciplines = [];
      this.disciplineArray = [];
      this.disciplineControl.setValue(null);
      this.selectedJournalTypes = [];
      this.journalTypeArray = [];
      this.journalTypeControl.setValue(null);
      this.selectedRange = '';
      this.dateRange = '';
      this.startDate = '';
      this.endDate = '';
      this.editorial = false;
    }
  }

  clearFilter(filterType: string) {
    if (filterType === 'discipline') {
      this.selectedDisciplines = [];
      this.disciplineArray = [];
      this.disciplineControl.setValue(null);
    }
    if (filterType === 'journalType') {
      this.selectedJournalTypes = [];
      this.journalTypeArray = [];
      this.journalTypeControl.setValue(null);
    }
  }

  applyFilters() {
    const data = {
      selected_order: this.selectedOrder,
      selectedDisciplines: this.selectedDisciplines,
      disciplineArray: this.disciplineArray,
      selectedJournalTypes: this.selectedJournalTypes,
      journalTypeArray: this.journalTypeArray,
      dateRange: this.dateRange,
      selectedRange: this.selectedRange,
      startDate: this.startDate,
      endDate: this.endDate,
      userFilterValue: this.userFilterValue.value,
      referenceFilterValue: this.referenceFilterValue.value,
      editorial: this.editorial
    };
    this.dialogRef.close(data);
  }

  close() {
    this.dialogRef.close();
  }

}
